import React, { useEffect, useState } from 'react'
import DashboardLayout from '../../../../components/layouts/dashboard'
import TabView from '../../../../components/tabview'
import TrainingOverviewTab from '../../../../components/employee-training/training-list'
import EmployeeTrainersTab from '../../../../components/employee-training/trainers'
import UnauthorizedPage from '../../../errors/unauthorized'
import { useSelector } from 'react-redux'
import AddTraining from '../../../../components/modal/hr-section/employee-training/add-training'
import Button from '../../../../components/button'
import { useGetEmployees } from '../../../../redux/employees/hook'

const HRTrainingPage = () => {
  useEffect(() => {}, [])

  const { user } = useSelector((state) => state.userSlice)
  const [unauthorized, setUnauthorized] = useState(false)
  const [showAddTraining, setShowAddTraining] = useState(false)
  const [trainingData, setTrainingData] = useState(null)
  const { data: employees } = useGetEmployees(9, 1, -1, '')
  const [headerText, setHeaderText] = useState('')
  const [trainerChangeType, setTrainerChangeType] = useState('')

  useEffect(() => {
    if (user) {
      if (user.permissions.company_permission.role !== 'Owner') {
        if (user.permissions.company_permission.training_read !== 1) {
          setUnauthorized(true)
        }
      }
    }
  }, [user])

  const [activeTab, setActiveTab] = useState(1)

  const RecruitmentTabs = [
    {
      title: 'Published Training',
      Content:
        user?.permissions.training_permission.training_read === 1 ||
        user?.permissions.company_permission.role === 'Owner'
          ? TrainingOverviewTab
          : UnauthorizedPage,
    },
    {
      title: 'Drafts / Unpublished Trainings',
      Content:
        user?.permissions.training_permission.trainer_read === 1 ||
        user?.permissions.company_permission.role === 'Owner'
          ? EmployeeTrainersTab
          : UnauthorizedPage,
    },
  ]

  return (
    <DashboardLayout title='Employee Training Management'>
      {unauthorized ? (
        <UnauthorizedPage />
      ) : (
        <>
          {showAddTraining ? (
            <AddTraining
              isOpen={showAddTraining}
              closeModal={() => setShowAddTraining(false)}
              trainingData={trainingData}
              headerText={headerText}
              trainerChangeType={trainerChangeType}
            />
          ) : null}
          <div className='flex flex-col'>
            <div className='flex flex-col md:flex-row justify-between items-center px-4 gap-[10px] my-2 mt-3'>
              <div className='md:flex hidden md:justify-start justify-center p3-bold header-4 md:w-[40%] w-full'>
                Employee Training
              </div>
              <div className='flex flex-col md:flex-row items-start gap-[10px] md:justify-end md:w-[60%] w-full'>
                <div className='md:w-fit w-[100%]'>
                  <Button
                    text='New Employee Training'
                    type='button'
                    theme='primary'
                    className='flex gap-2 !h-[35px] md:w-fit w-full px-2 items-center'
                    textClass={'!text-[11px]'}
                    leftIcon={'add'}
                    disabled={!employees}
                    onClick={() => {
                      setTrainingData(null)
                      setShowAddTraining(true)
                      setTrainerChangeType('add')
                      setHeaderText('New Employee Training')
                    }}
                  />
                </div>
              </div>
            </div>

            <div className='mt-2'>
              <TabView
                Tabs={RecruitmentTabs}
                activeTab={activeTab}
                setActiveTab={setActiveTab}
              />
            </div>
          </div>
        </>
      )}
    </DashboardLayout>
  )
}

export default HRTrainingPage
